import { cn } from '../../../libs/utils';

import { TextListProps } from './..';

export const BulletArea = ({ children, size }: Pick<TextListProps, 'children' | 'size'>) => {
  return (
    <div
      className={cn('flex items-center', {
        'pl-tiny-medium': size === 'large' || size === 'medium',
        'px-tiny-small': size === 'small',

        'h-[22px]': size === 'large',
        'h-[21px]': size === 'medium',
        'h-[19px]': size === 'small'
      })}
    >
      {children}
    </div>
  );
};

export const Bullet = ({ bulletColor, size }: Pick<TextListProps, 'bulletColor' | 'size'>) => {
  const bulletStyle = bulletColor ? { backgroundColor: bulletColor } : {};

  return (
    <div
      aria-hidden={true}
      className={cn('shrink-0 rounded-[3px] bg-neutral-foreground-low', {
        'h-[4px] w-[4px]': size === 'large' || size === 'medium',
        'h-[3px] w-[3px]': size === 'small'
      })}
      style={bulletStyle}
      data-testid="bullet"
    />
  );
};
